import React from 'react';
import { Select } from 'antd';
import { get } from '../../../../common/utils';
import style from './index.module.scss';

const { Option } = Select;

export default class SearchSelect extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: props.value || '',
            dataList: [],
            searchApi: props?.searchApi ?? null,
        };

        /**
         * 防止组件卸载后 setState
         */
        this._isMounted = false;
    }

    componentDidMount() {

        this._isMounted = true;

        this.updateValue(this.props);

        /**
         * 初始化加载数据
         */
        let searchValue = this.props.value;

        if (!searchValue) {
            searchValue = '';
        }

        this.handleSearch(searchValue);
    }

    componentDidUpdate(prevProps) {

        /**
         * value变化时同步
         */
        if (prevProps.value !== this.props.value) {

            this.updateValue(this.props);

        }

        /**
         * searchApi变化时同步
         */
        if (prevProps.searchApi !== this.props.searchApi) {

            this.setState({
                searchApi: this.props.searchApi ?? null,
            });

        }
    }

    componentWillUnmount() {

        this._isMounted = false;

    }

    /**
     * 更新 value
     */
    updateValue = (props) => {

        const value = props.value || '';

        /**
         * 避免重复 setState
         */
        if (value !== this.state.value) {

            this.setState({
                value,
            });

        }

        /**
         * 避免重复 onChange
         */
        if (value !== props.value) {

            props.onChange?.(value);

        }
    }

    /**
     * 搜索
     */
    handleSearch = (value) => {

        const { searchApi } = this.state;

        if (typeof searchApi !== 'string') {

            return;

        }

        let combinedQuery = searchApi;

        if (
            typeof value === 'string'
            && value !== ""
        ) {

            if (combinedQuery.indexOf("?") !== -1) {

                combinedQuery += "&";

            } else {

                combinedQuery += "?";

            }

            combinedQuery += `keyword=${value}`;
        }

        get(
            process.env.REACT_APP_SERVER_PATH + combinedQuery,
            {}
        ).then((retData) => {

            /**
             * 组件已经卸载
             */
            if (!this._isMounted) return;

            let results =
                retData?.data?.results ?? [];

            /**
             * 去重
             */
            let dataList = [];

            results.forEach(item => {

                if (
                    item?.full_name
                    && dataList.indexOf(item.full_name) < 0
                ) {
                    dataList.push(item.full_name);
                }

            });

            /**
             * 避免重复 setState
             */
            if (
                JSON.stringify(dataList)
                !== JSON.stringify(this.state.dataList)
            ) {

                this.setState({
                    dataList,
                });

            }

        }).catch(() => {

            /**
             * 防止请求报错导致页面崩
             */
        });
    }

    /**
     * 选择
     */
    handleChange = (value) => {

        const finalValue = value || '';

        /**
         * 避免重复更新
         */
        if (finalValue !== this.state.value) {

            this.setState({
                value: finalValue,
            });

        }

        /**
         * 通知表单
         */
        if (finalValue !== this.props.value) {

            this.props.onChange?.(finalValue);

        }

        /**
         * allowClear 后重新加载数据
         */
        if (value === undefined) {

            this.handleSearch('');

        }
    }

    render() {

        const {
            value,
            dataList,
        } = this.state;

        return (
            <Select
                showSearch
                className={style['wrapper']}
                value={value || undefined}
                placeholder={this.props.placeholder}
                style={{
                    maxWidth: "calc(100vw - 142px)",
                    minWidth: "288px",
                    fontSize: "12px",
                }}
                allowClear={true}
                defaultActiveFirstOption={false}
                filterOption={false}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                notFoundContent={null}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >

                {
                    dataList.map(item => (
                        <Option
                            key={item}
                            value={item}
                        >
                            {item}
                        </Option>
                    ))
                }

            </Select>
        );
    }
}